import React, { useState, useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import Cookies from 'js-cookie'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
// import { adminMainUrl } from '../../../Config';
// import { adminLoginSchema } from '../../../ValidationScema';
import 'react-toastify/dist/ReactToastify.css';
// import Api from '../../../Api';
// import { getRoleList, getRoleView } from '../../../Redux/action/Admin/RolePermissionAction';
import { useDispatch, useSelector } from 'react-redux';
// import { getRoleView } from '../../Redux/action/Admin/RolePermissionAction';
import { adminLoginSchema } from '../../ValidationScema';
import { adminMainUrl, HRMSGOURL } from '../../Config';
import { getRoleView } from '../../Redux/action/HRMS/Login/LoginMasterAction';
import { capitalizeFirstLetter, getHrmsUrl } from '../../HelperFunctions';

const LoginHRMS = ({
    CompanyDetailData,
    loadingCompanyDetail
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [roleId, setRoleId] = useState([]);
    let [roleOptions, setRoleOptions] = useState([]);

    useEffect(() => {
        dispatch(getRoleView());
    }, []);

    let [HRMS_URL, setHRMS_URL] = useState(getHrmsUrl());


    let roleData = useSelector(state => state?.LoginMasterReducer ? state?.LoginMasterReducer?.roleViewData : []);
    console.log(roleData, 'this is role view data how does it');

    useEffect(() => {
        if (roleData) {
            // let roleArr = [{ value: "Admin", label: "Admin" }];
            let roleArr = [];
            roleData.map(val => { roleArr.push({ value: val.name, label: capitalizeFirstLetter(val.name) }) });
            setRoleOptions(roleArr);
        }
    }, [roleData]);

    const initialValues = {
        email: "",
        password: "",
        role_name: "",
        // agreement: false,
    };
    const burl = new URLSearchParams(window.location.search).get('burl');
    useEffect(() => {
        const token = Cookies.get("token");
        if (token) {
            navigate('/flexichain/dashboard');
        }
    }, [navigate]);



    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            email: Yup.string()
                .email("Please enter a valid email address.")
                .required("Please enter your email address."),
            password: Yup.string()
                .required("Please enter your password.")
                .min(4, "Password must be at least 4 character"),
            role_name: Yup.string().required('Please select role'),
        }),
        onSubmit: async (values) => {
            // console.log(values);
            setIsSubmitting(true);
            try {
                const response = await fetch(`${adminMainUrl}/api/login-new`, {
                    method: "POST",
                    body: JSON.stringify(values),
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                });

                const data = await response.json();

                if (data?.code === 200) {
                    toast.success(data?.msg);
                    if (data?.data) {
                        Cookies.set("token", data?.data.token);
                        Cookies.set("flexichain_user_id", (data?.data?.user_id));
                        // Cookies.set("user_id", String(data?.data.user_id), { raw: true });
                        if (burl) {
                            navigate(`/${burl}`);
                        }
                        else {
                            if (data?.data.role.toLowerCase().includes("sales")) {
                                navigate('/flexichain/sales-dashboard');
                            } else if (data?.data.role.toLowerCase().includes("pricing")) {
                                navigate('/flexichain/pricing/air/import/rate-request/requested');
                            } else if (data?.data.role.toLowerCase().includes("admin")) {
                                navigate('/flexichain/dashboard');
                            } else {
                                navigate(`/flexichain/dashboard`)
                            }
                        }
                    } else {
                        toast.error("Failed to get data. Redirecting to login...");
                        navigate('/login');
                    }
                } else {
                    toast.error(data?.msg);
                    // handle login failure
                }
            } catch (error) {
                console.error("Login error:", error);
                toast.error("An error occurred. Please try again.");
            } finally {
                setIsSubmitting(false); // Stop the spinner
            }
        },
    });

    // useEffect(() => {
    //     if (formik.errors) { console.log(formik.errors) }
    // }, [formik.errors])


    return (
        <>
            <div className="account-page">
                <div className="main-wrapper">
                    <div className="account-content">
                        <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden account-bg-01">
                            <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
                                {/* <form action="index.html" className="flex-fill"> */}
                                <form className="flex-fill" onSubmit={formik.handleSubmit}>
                                    {/* <form className="" > */}
                                    <div className="mx-auto mw-450">
                                        <div className="text-center mb-4">
                                            <img
                                                src={CompanyDetailData ? CompanyDetailData.logo_path : "/assets/img/logo.png"}
                                                className="img-fluid company-logo-flexichain-login"
                                                alt="Logo"
                                                onError={({ currentTarget }) => {
                                                    currentTarget.onerror = null;
                                                    currentTarget.src = "/assets/img/logo.png";
                                                }}
                                            />
                                        </div>
                                        {/* <div className="mb-4">
                                            <h4 className="mb-2 fs-20">Sign In</h4>
                                            <p>Access the CRMS panel using your email and passcode.</p>
                                        </div> */}
                                        <div className="mb-3">
                                            <label className="col-form-label">Select Your Role</label>
                                            <div className="position-relative">
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-mail" />
                                                </span>
                                                <Select
                                                    className='mt-2'
                                                    options={roleOptions}
                                                    name="role_name"
                                                    value={roleOptions.find(option => option.value === formik.values.role_name)}
                                                    onChange={option => formik.setFieldValue('role_name', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </div>
                                            {formik.errors.role_name && formik.touched.role_name && (
                                                <div className="text-red-500 text-base">{formik.errors.role_name}</div>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Email Address</label>
                                            <div className="position-relative">
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-mail" />
                                                </span>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    className="form-control"
                                                    placeholder="Enter Email Address"
                                                    name="email"
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    style={{
                                                        background: "#fff",
                                                        border: formik.errors.email && formik.touched.email ? "1px solid red" : "",
                                                    }}
                                                />
                                            </div>
                                            {formik.errors.email && formik.touched.email && (
                                                <div className="text-red-500 text-base">{formik.errors.email}</div>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Password</label>
                                            <div className="pass-group">
                                                <input
                                                    placeholder='Enter Your Password'
                                                    type={showPassword ? "password" : "text"}
                                                    id="password"
                                                    className="pass-input form-control"
                                                    name="password"
                                                    value={formik.values.password}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    style={{
                                                        background: "#fff",
                                                        border: formik.errors.password && formik.touched.password ? "1px solid red" : "",
                                                    }}
                                                />
                                                {
                                                    showPassword ?
                                                        <VisibilityOffIcon className='cursor-pointer toggle-password' style={{ fill: "rgb(82 80 80)" }} onClick={() => { setShowPassword(!showPassword) }} />
                                                        :
                                                        <VisibilityIcon className='cursor-pointer toggle-password' style={{ fill: "rgb(82 80 80)" }} onClick={() => { setShowPassword(!showPassword) }} />
                                                }
                                                {/* <span className="ti toggle-password ti-eye-off" /> */}
                                            </div>
                                            {formik.errors.password && formik.touched.password && (
                                                <div className="text-red-500 text-base">{formik.errors.password}</div>
                                            )}
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <div className="form-check form-check-md d-flex align-items-center">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    defaultValue=""
                                                    id="checkebox-md"
                                                    defaultChecked=""
                                                />
                                                <label className="form-check-label" htmlFor="checkebox-md">
                                                    Remember Me
                                                </label>
                                            </div>
                                            <div className="text-end">
                                                <Link to="/forget-email"
                                                    className="text-primary fw-medium link-hover">
                                                    Forgot Password?
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <button className="btn btn-primary w-100 btn-home-page-cus" type="submit" disabled={isSubmitting}>
                                                {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Login"}
                                            </button>
                                            {/* <button type="submit" className="btn btn-primary w-100">
                                                Sign In
                                            </button> */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                }}
                                                className='my-2'
                                            >
                                                <hr
                                                    style={{
                                                        flexGrow: 1,
                                                        border: 'none',
                                                        borderTop: '1px solid rgb(0 0 0)',
                                                        margin: '0 10px',
                                                    }}
                                                />
                                                <span
                                                    style={{
                                                        whiteSpace: 'nowrap',
                                                        fontSize: '14px',
                                                        color: '#666',
                                                    }}
                                                >
                                                    or
                                                </span>
                                                <hr
                                                    style={{
                                                        flexGrow: 1,
                                                        border: 'none',
                                                        borderTop: '1px solid rgb(0 0 0)',
                                                        margin: '0 10px',
                                                    }}
                                                />
                                            </div>


                                            <a href={`${HRMS_URL}/login`} target='_blank' className="btn w-100 login-btn-hrms btn-home-page-cus" type="submit" >
                                                Login to HRMS {" "}<i className="fas fa-external-link"></i>
                                            </a>

                                            {/* <div className="text-center">
                                                <a href='https://hrms.flexichains.com/login' target='_blank' className="fw-medium text-gray">Login to HRMS {" "}<i className="fas fa-external-link"></i></a>
                                            </div> */}
                                        </div>
                                        {/* <div className="mb-3">
                                            <h6>
                                                New on our platform?
                                                <a href="register.html" className="text-purple link-hover">
                                                    {" "}
                                                    Create an account
                                                </a>
                                            </h6>
                                        </div> */}
                                        {/* <div className="form-set-login or-text mb-3">
                                            <h4>OR</h4>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center flex-wrap mb-3">
                                            <div className="text-center me-2 flex-fill">
                                                <a
                                                    href="javascript:void(0);"
                                                    className="br-10 p-2 px-4 btn bg-pending  d-flex align-items-center justify-content-center"
                                                >
                                                    <img
                                                        className="img-fluid m-1"
                                                        src="assets/img/icons/facebook-logo.svg"
                                                        alt="Facebook"
                                                    />
                                                </a>
                                            </div>
                                            <div className="text-center me-2 flex-fill">
                                                <a
                                                    href="javascript:void(0);"
                                                    className="br-10 p-2 px-4 btn bg-white d-flex align-items-center justify-content-center"
                                                >
                                                    <img
                                                        className="img-fluid  m-1"
                                                        src="assets/img/icons/google-logo.svg"
                                                        alt="Facebook"
                                                    />
                                                </a>
                                            </div>
                                            <div className="text-center flex-fill">
                                                <a
                                                    href="javascript:void(0);"
                                                    className="bg-dark br-10 p-2 px-4 btn btn-dark d-flex align-items-center justify-content-center"
                                                >
                                                    <img
                                                        className="img-fluid  m-1"
                                                        src="assets/img/icons/apple-logo.svg"
                                                        alt="Apple"
                                                    />
                                                </a>
                                            </div>
                                        </div> */}

                                        <div className="text-center">
                                            <p className="fw-medium text-gray">Copyright © 2024 - Flexichain</p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default LoginHRMS